<template>
  <v-text-field
    class="my-text-field text-right"
    style="margin-top: 0px; margin-bottom: -30px"
    :background-color="disabled ? '#d3d3d3' : ''"
    :style="{ width: width }"
    full-width
    outlined
    rounded
    v-model="displayValue"
    ref="myAmountInput"
    @focus="handleFocus"
    @keyup="(e) => doKeyUp(e.target.value)"
    @blur="(e) => doOnBlur(e.target.value)"
    :disabled="disabled"
    :error-messages="errorsMsg"
  >
  </v-text-field>
</template>

<script>
export default {
  name: 'AmountInput',
  props: {
    value: {
      type: [String, Number],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorsMsg: {
      type: [String, Array],
    },
    width: {
      type: String,
      default() {
        return '120px';
      },
    },
    toFixed: {
      type: [String, Number],
      default() {
        return 0;
      },
    },
    allowNegative: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayValue: 0,
      keyUpTimeout: 0,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.formatAmount(val);
      },
      deep: true,
    },
  },
  mounted() {
    this.formatAmount(this.value);
  },
  methods: {
    doFunction() {
      this.$emit('doFuntion');
    },
    doKeyUp(value) {
      // 根據 allowNegative 決定過濾規則
      let cleaned = String(value);

      if (!this.allowNegative) {
        // 【不允許負數】時的正則：只留數字與小數點 (完全濾掉 '-')
        cleaned = cleaned
          .replace(/[^0-9.]/g, '')
          .replace(/^(?:\.)/g, '0.');
      } else {
        // 【允許負數】時的正則：保留原本的負號邏輯
        cleaned = cleaned
          .replace(/[^0-9.-]/g, '')
          .replace(/(?!^)-/g, '')
          .replace(/^(?:\.|-\.)/g, (matched) => (matched === '.' ? '0.' : '-0.'));
      }

      // 共通的小數點防呆處理（避免多個小數點）
      cleaned = cleaned
        .replace(/\.{2,}/g, '.')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.');

      this.displayValue = cleaned;

      if (this.keyUpTimeout) {
        clearTimeout(this.keyUpTimeout);
      }

      this.keyUpTimeout = setTimeout(() => {
        if (this.displayValue === '-') {
          this.displayValue = 0;
        }

        const valueToFixed = Math.round(Number(this.displayValue) * 10 ** this.toFixed) / 10 ** this.toFixed;
        this.$emit('input', Number(valueToFixed));
      }, 1000);
    },
    doOnBlur(value) {
      this.$emit('doOnBlur');
      clearTimeout(this.keyUpTimeout);
      this.formatAmount(value);
    },
    // 合選欄位值
    handleFocus() {
      // console.log(currentField);
      this.$nextTick(() => {
        const inputElement = this.$refs.myAmountInput.$el.querySelector('input');
        // console.log(inputElement);

        inputElement.select();
      });
    },
    // 物件中的金額格式化
    formatAmount(value) {
      if (value === '-') {
        value = 0;
      }

      value = value.toString().replaceAll(',', '');
      const valueToFixed = Math.round(Number(value) * 10 ** this.toFixed) / 10 ** this.toFixed;
      this.$emit('input', Number(valueToFixed));
      if (this.toFixed === 0) {
        this.displayValue = Number(valueToFixed)
          .toString()
          .replace(/(\d)(?=(\d{3})+$)/g, '$1,');
      } else {
        const val = valueToFixed.toFixed(this.toFixed).toString().split('.');
        val[0] = val[0]
          .replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        this.displayValue = val.join('.');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  width: 160px;
  display: inline-block;
  i {
    cursor: pointer;
  }
}

::v-deep.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
  .v-input__append-inner {
    margin-top: 0 !important;
    height: 100%;
    display: flex;
    align-items: center;
  }

  input {
    text-align: right;
    margin-right: -14px;
  }
}
</style>
